import { useQuery } from '@tanstack/react-query';
import { COMPLIANCE_TIMEOUT_MS, runComplianceRequest } from 'src/api/complianceRequest';
import { HandshakePainterServiceApiV1 } from 'src/api/handshakeApi';
import { useAnalyticsContext } from 'src/common/metrics';
import { useDefaultApiParams } from './useDefaultApiParams';
/**
 * Custom hook to fetch standard-priority product compliance data based on a single ASIN
 */
export const useProductComplianceStandardPriority = ({ asin, enabled = true, }) => {
    const defaultApiParams = useDefaultApiParams().getDefaultParams();
    const rumClient = useAnalyticsContext();
    return useQuery({
        queryKey: ['getProductComplianceStandard', asin],
        queryFn: ({ signal }) => runComplianceRequest({
            eventPrefix: 'COMPLIANCE_STANDARD_PRIORITY',
            asin,
            timeoutMs: COMPLIANCE_TIMEOUT_MS.STANDARD_PRIORITY,
            querySignal: signal,
            rumClient,
            request: (requestSignal) => HandshakePainterServiceApiV1.getProductComplianceStandard({
                asin: asin,
                xUserLinked: defaultApiParams.xUserLinked,
                xJoinId: defaultApiParams.xJoinId,
                marketplaceId: defaultApiParams.marketplaceId,
            }, { signal: requestSignal }),
        }),
        enabled: enabled && !!asin,
    });
};
